import React from 'react';
import { Typography } from '../../../../components';
import { IcDate, ClockIc } from '../../../../components/icons';
import { OrderData } from '../types';
import { useTranslations } from '../../../../contexts/translation.context';

interface DateCellProps {
  order: OrderData;
}

const DateCell: React.FC<DateCellProps> = ({ order }) => {
  const { t } = useTranslations();

  const parseOrderDate = (value?: string): Date | null => {
    if (!value) return null;
    const trimmed = value.trim();
    if (!trimmed) return null;

    const normalized = trimmed.replace(' ', 'T');
    // if backend already provides timezone leave as-is
    const hasTimeZone = /([zZ]|[+\-]\d{2}:?\d{2})$/.test(normalized);

    if (hasTimeZone) {
      const parsed = new Date(normalized);
      return Number.isNaN(parsed.getTime()) ? null : parsed;
    }

    const [datePart, timePart = ''] = normalized.split('T');
    const [yearStr, monthStr, dayStr] = datePart.split('-');
    const [timeWithoutMs, msPart] = timePart.split('.');
    const [hourStr = '0', minuteStr = '0', secondStr = '0'] = (timeWithoutMs || '').split(':');

    const year = Number(yearStr);
    const monthIndex = Number(monthStr) - 1;
    const day = Number(dayStr);
    const hour = Number(hourStr);
    const minute = Number(minuteStr);
    const second = Number(secondStr);
    const millisecond = msPart ? Number(msPart.padEnd(3, '0').slice(0, 3)) : 0;

    if (
      [year, monthIndex, day, hour, minute, second, millisecond].some((val) => Number.isNaN(val))
    ) {
      return null;
    }

    const utcTimestamp = Date.UTC(year, monthIndex, day, hour, minute, second, millisecond);
    return new Date(utcTimestamp);
  };

  const date = parseOrderDate(order.startDate);
  const isValidDate = !!date;

  return (
    <div className="flex  gap-2">
      <div className="flex items-center gap-1 ">
        <IcDate className="w-3.5 h-3.5 text-gray-600" />
        <Typography variant="body3" className="text-gray-600">
          {isValidDate ? date!.toLocaleDateString('ru-RU') : '—'}
        </Typography>
      </div>
      <div className="flex items-center gap-1 ">
        <ClockIc />
        <Typography variant="body3" className="text-gray-600">
          {isValidDate
            ? date!.toLocaleTimeString('ru-RU', {
                hour: '2-digit',
                minute: '2-digit',
              })
            : '—'}
        </Typography>
      </div>
    </div>
  );
};

export default DateCell;
